import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createAction, createReducer, on, createSelector, props, createActionGroup, createFeature } from '@ngrx/store';

import { AlertMessage } from './../../../globalTypes/alert.types';

export interface AlertsState extends EntityState<AlertMessage> {}

export const adapter = createEntityAdapter<AlertMessage>({
  selectId: (alert) => alert.id,
  sortComparer: (a, b) => b.createdAt - a.createdAt,
});

export const initialState: AlertsState = adapter.getInitialState();

// Actions
export const alertActions = createActionGroup({
  source: 'alert',
  events: {
    'Add Alert': (alert: AlertMessage) => ({ alert }),
    'Dismiss Alert': (id: string) => ({ id }),
  },
});

// Reducer
export const alertsReducer = createReducer(
  initialState,
  on(alertActions.addAlert, (state, { alert }) => adapter.addOne(alert, state)),
  on(alertActions.dismissAlert, (state, { id }) => adapter.removeOne(id, state))
);

// Selectors
const { selectAll } = adapter.getSelectors();

export const selectAllAlerts = (state: { alerts: AlertsState }) => selectAll(state.alerts);

export const alertFeature = createFeature({
  name: 'alert',
  reducer: alertsReducer,
  extraSelectors: ({selectIds, selectEntities}) => ({
    selectAll: createSelector(selectIds, selectEntities, (ids, entities) => ids ? ids.map((id) => entities[id]) : []),
  }),
})